import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'admin-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit {

  public params:any = {}

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {
    for (const key in data) {
        this.params[key] = data[key];
    }

    if (this.params.type == null) {
        this.params.type = 'dialog';
    }
  }

  ngOnInit(): void {
  }

}



// WEBPACK FOOTER //
// ./src/app/@core/lib/toast/toast.component.ts